import React from "react";
import { VARIABLE_ICONS } from "../../../components/Workflow/WorkflowVariables/workflowVariables.constants";

/**
 * ChipsVariableItem component for rendering a single chip variable item
 * @author Muskan Thakur
 */
const ChipsVariableItem = ({ variable, onClick }) => {
  const actualType = variable?.attributes?.numberOnly ? "number_dropdown" : variable?.type;

  return (
    <div
      key={variable?.id}
      className='d-flex align-items-center justify-content-between px-3 py-2 cursor-pointer workflow-variable-item border-0 m-0'
      onClick={onClick}>
      <div className='d-flex justify-content-between align-items-center'>
        <span>{VARIABLE_ICONS[actualType]}</span>
        <span className='ml-2'>{variable?.name}</span>
      </div>
    </div>
  );
};

export default React.memo(ChipsVariableItem);
